import type { QueryClient } from '@tanstack/react-query'

/**
 * Refresh the vendor engagement explorer (dropdown summary + per-vendor
 * breakdown) after a mutation that changes assignments, invitations, or awards.
 *
 * Partial-key matching covers every vendor's detail query at once, and
 * refetchType:'active' only refetches when an engagement view is actually
 * mounted — so calling this during normal WO/task editing is a no-op.
 *
 * Keys mirror `vendorKeys.withEngagement` / `vendorKeys.engagements` in
 * use-vendors.ts. This lives in its own module (rather than use-vendors.ts) so
 * that hot mutation files importing it don't pull in that file's heavy PostgREST
 * select types, which sit at TypeScript's instantiation-depth limit.
 */
export function invalidateVendorEngagements(qc: QueryClient) {
  qc.invalidateQueries({ queryKey: ['vendors', 'with-engagement'], refetchType: 'active' })
  qc.invalidateQueries({ queryKey: ['vendors', 'engagements'], refetchType: 'active' })
}
